import { useCallback, useState } from 'react';
import { Button } from '../../button';
import { MAX_ZOOM, MIN_ZOOM, useImagePreviewActions } from '../provider/image-preview.provider';
import { controlStyles, IconButtonStyles, MAX_RANGE_VALUE, MIN_RANGE_VALUE, STEP } from './constants';

const mapRange = (value, inMin, inMax, outMin, outMax) => {
  return ((value - inMin) * (outMax - outMin)) / (inMax - inMin) + outMin;
};

export const ZoomSlider = () => {
  const { changeZoom } = useImagePreviewActions();
  const [value, setValue] = useState(MIN_RANGE_VALUE);

  const updateZoom = (newValue: number) => {
    const clamped = Math.min(MAX_RANGE_VALUE, Math.max(MIN_RANGE_VALUE, newValue));
    setValue(clamped);
    const zoomValue = mapRange(clamped, MIN_RANGE_VALUE, MAX_RANGE_VALUE, MIN_ZOOM, MAX_ZOOM);
    changeZoom(zoomValue);
  };

  const handleMinus = useCallback(() => updateZoom(value - STEP), [value]);
  const handlePlus = useCallback(() => updateZoom(value + STEP), [value]);
  const handleChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => updateZoom(e.target.valueAsNumber), []);

  return (
    <div css={controlStyles}>
      <Button iconName='minus-small' color='white' css={IconButtonStyles} onClick={handleMinus} />
      <input
        type='range'
        min={MIN_RANGE_VALUE}
        max={MAX_RANGE_VALUE}
        value={value}
        onChange={handleChange}
        css={{ cursor: 'pointer' }}
      />
      <Button iconName='plus-small' color='white' css={IconButtonStyles} onClick={handlePlus} />
    </div>
  );
};

ZoomSlider.displayName = 'ZoomSlider';
